module.exports = __webpack_public_path__ + "static/xray-f8c0e57eff03c70037806c161504cacc.jpg";